import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import get from 'lodash/get';
import {
  Button,
  Card,
  CardContent,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
} from '@material-ui/core';
import axios from 'axios';

import Loader from '../../../components/Loader';

class QuizInstruction extends React.Component {
  static propTypes = {
    candidateId: PropTypes.string.isRequired,
    startQuiz: PropTypes.func.isRequired,
  };

  state = {
    dataLoaded: false,
    data: null,
    error: null,
    language: 'english',
  };

  async componentDidMount() {
    try {
      const { data } = await axios.get(
        `https://us-central1-jyp-admin-saas.cloudfunctions.net/quiz/verify/?id=${
          this.props.candidateId
        }`,
      );

      this.setState({ dataLoaded: true, data });
    } catch (error) {
      const errorMessage = get(error.response, 'data.data.errors.id');
      this.setState({ dataLoaded: true, error: errorMessage || error.message });
    }
  }

  render() {
    if (!this.state.dataLoaded) {
      return <Loader />;
    }

    if (this.state.error) {
      return <Error>{this.state.error}</Error>;
    }

    return (
      <div>
        <InstructionContainer>
          <InstructionCard>
            {this.state.data.success ? (
              <CardContent>
                <Typography variant="title" color="primary">
                  Instructions
                </Typography>

                <ul>
                  <li>
                    <Typography variant="subheading">
                      There are 20 single choice Questions to be answered.
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="subheading">Each Questions carry 5 marks.</Typography>
                  </li>
                  <li>
                    <Typography variant="subheading">
                      You have 10 minutes to complete the test.
                    </Typography>
                  </li>
                </ul>

                <div>
                  <Typography variant="subheading">Choose the Quiz language</Typography>
                  <StyledRadioGroup
                    aria-label="quiz-language"
                    name="quiz-language"
                    value={this.state.language}
                    onChange={(event) => {
                      const { value } = event.target;
                      this.setState({ language: value });
                    }}
                  >
                    <FormControlLabel
                      value="english"
                      control={<Radio color="primary" />}
                      label="English"
                    />
                    <FormControlLabel
                      value="hindi"
                      control={<Radio color="primary" />}
                      label="Hindi"
                    />
                  </StyledRadioGroup>
                </div>

                <ButtonContainer>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      this.props.startQuiz({ language: this.state.language });
                    }}
                  >
                    Start Test
                  </Button>
                </ButtonContainer>
              </CardContent>
            ) : (
              <CardContent>
                <Typography variant="subheading">You have already submitted the quiz.</Typography>
              </CardContent>
            )}
          </InstructionCard>
        </InstructionContainer>
      </div>
    );
  }
}

export default QuizInstruction;

const Error = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
`;

const InstructionContainer = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
`;

const InstructionCard = styled(Card)`
  width: 90%;
  max-width: 960px;
  height: fit-content;
  margin-top: 50px;
`;

const ButtonContainer = styled.div`
  text-align: center;
  margin-top: 30px;
`;

const StyledRadioGroup = styled(RadioGroup)`
  display: flex !important;
  align-items: center !important;
  flex-direction: row !important;
`;



// WEBPACK FOOTER //
// ./src/pages/RegistationQuiz/components/QuizInstruction.js